module.exports = __webpack_public_path__ + "static/media/hero-slider-video.b2e63b29.mp4";